"use strict";

const MuniManholeGeoServerLayer = function () {
  const layerName = "muniManhole";
  const layerKey = "muniManholeLayer";

  var createMarkerFunction = function (feature, latlng) {
    return L.marker(latlng, {
      icon: createIcon(feature.properties.icon.class),
    });
  };

  var createIcon = function (iconClass) {
    return L.divIcon({
      iconSize: ManholesIcon._updateIconSizeOnZoom(),
      popupAnchor: [0, 5],
      className: iconClass,
    });
  };

  var getUnsavedIconMarker = function () {
    return createIcon(RoutineMaintenanceIcon.getMaintenanceIcon("muni-manhole", null).class);
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const muniManholeGeoServerLayer = new GeoServerMapLayer(
      layerName,
      layerKey,
      createMarkerFunction,
    );
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, muniManholeGeoServerLayer);

    muniManholeGeoServerLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    muniManholeGeoServerLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    if (Tree.get("dataView") === "dry-weather") {
      MonitoringLocationGeoServerLayer.invalidateLayerData();
      return;
    }

    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await GeoServerLayerFunctions.getFeaturesForLayer(
      layerName,
      onlineFiltering,
      loadingScreen,
    );
    return organizeMuniLayerData(data);
  };

  var organizeMuniLayerData = function (layerData) {
    return layerData.map(function (data) {
      return getOrganizedProperties(data.properties, data.geometry);
    });
  };

  var getOrganizedProperties = function (data, geometry) {
    return {
      id: data.id,
      groupId: data.group_id,
      geometry: geometry,
      manholeName: data.manhole_name,
      manholeType: data.manhole_type,
      address: data.address,
      cof: data.cof_final_text,
      coverShape: data.cover_shape,
      icon: RoutineMaintenanceIcon.getMaintenanceIcon("muni-manhole", data.condition),
      maintainerType: data.maintainer_type,
      implementerType: data.implementer_type,
      responsiblePartyMaintenance: data.responsible_party_maintenance,
      phase: data.phase,
      installDate: data.install_date,
      landOwnership: data.property,
      correctiveAction: JSON.parse(data.corrective_actions),
      enforcementLevel: JSON.parse(data.severity),
      manholeDiameter: data.manhole_diameter,
      manholeDiameterUnits: data.manhole_diameter_units,
      manholeLength: data.manhole_length,
      manholeLengthUnits: data.manhole_length_units,
      manholeWidth: data.manhole_width,
      manholeWidthUnits: data.manhole_width_units,
      catchment_name: data.catchment_name,
      drains_to_rw: data.drains_to_rw,
      drains_to_c: data.drains_to_c,
      zone_names: data.zone_names,
      routine: DateTime.parseJsonIsoDateArray(data.routine_inspection_dates),
      repair: DateTime.parseJsonIsoDateArray(data.repair_dates),
    };
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    getLayerData,
    invalidateLayerData,
    organizeMuniLayerData,
    getUnsavedIconMarker,
  };
};

module.exports = MuniManholeGeoServerLayer();

const GeoServerLayerFunctions = require("../mapFunctions/geoServerLayerFunctions");
const GeoServerMapLayer = require("../mapFunctions/geoServerMapLayer");
const RoutineMaintenanceIcon = require("../general/routineMaintenanceIcon");
const ManholesIcon = require("./manholes/manholesIcon");
const DateTime = require("../dateTime");
const Tree = require("../tree");
const MonitoringLocationGeoServerLayer = require("../illicitDischarge/monitoringLocationGeoServerLayer");
